import { Button } from "@/components/ui/button";
import { useModalStore } from "@/stores/use-modal-store";
import { XMarkIcon } from "@heroicons/react/20/solid";
import MemoryUpgradeImg from "@/assets/report-assets/memory-upgrade.png";
import { requestDemo } from "@/api/manage/demo/api";
import { toast } from "@/components/ui/toast";
import { useState } from "react";
import { useSegment } from "@/hooks/use-segment";

/*
 * MemoryUpsellModal Component
 */
export const MemoryUpsellModal = () => {
  /* Hooks */
  const { close } = useModalStore((state) => state.modalActions);
  const { segmentTrackEvent } = useSegment();

  /* State */
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  /* Handlers */
  const handleBookDemo = async () => {
    setIsLoading(true);
    try {
      await requestDemo("memory");
      toast({
        title: "Request submitted, one of the advisors will contact you shortly.",
        type: "success",
      });

      // Segment event
      segmentTrackEvent("Studio Demo Requested", { demoType: "memory" });

      // Update state
      setIsSuccess(true);
    } catch {
      toast({
        title: "We couldn't submit your request. Please try again.",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  /* Render */
  return (
    <div className="flex flex-col gap-4 text-center">
      <div className="flex items-center justify-center relative">
        <XMarkIcon onClick={close} className="size-5 cursor-pointer absolute right-0" />
      </div>
      <img src={MemoryUpgradeImg} alt="Upgrade to Memory metrics" className="w-[300px] h-[300px] object-cover m-auto" />
      <h2>New Memory Scores</h2>
      <p className="leading-7">Find out whether your creative will be remembered and how to improve memorability. More memorable creative drives stronger results.</p>
      <div className="flex justify-center gap-4">
        <Button variant="primary" onClick={handleBookDemo} disabled={isSuccess || isLoading}>
          {isLoading && <span className="loading loading-spinner loading-sm mr-2"></span>}
          {isSuccess ? "Demo requested" : "Book demo"}
        </Button>
        <a href="https://academy.dragonflyai.co/en/articles/12787578-find-out-more-article" target="_blank" rel="noopener noreferrer">
          <Button>Find out more</Button>
        </a>
      </div>
    </div>
  );
};
